import { FormControlLabel, Checkbox } from "@mui/material";
import Box from "elements/Box";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import AutocompleteField from "elements/AutocompleteField";

export default function NursesFilters(props: any) {
  const { filters, setFilters } = props;

  const toggle = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    if (key === "advanced_wound_care" || key === "general_nurse") {
      setFilters({
        ...filters,
        advanced_wound_care: key === "advanced_wound_care" ? event.target.checked : false,
        general_nurse: key === "general_nurse" ? event.target.checked : false,
      });
    } else {
      setFilters({ ...filters, [key]: event.target.checked });
    }
  };

  return (
    <Box className="filters">
      <span className="filter_title">Filtrar búsqueda</span>

      <div className="filter_section">
        <h3>Prestaciones</h3>

        <FormControlLabel
          className="filter_checkbox"
          control={
            <Checkbox
              checked={filters.advanced_wound_care}
              onChange={toggle("advanced_wound_care")}
              icon={<RadioButtonUncheckedIcon />}
              checkedIcon={<CheckCircleIcon color="secondary" />}
            />
          }
          label="Especialista en Heridas"
        />

        <FormControlLabel
          className="filter_checkbox"
          control={
            <Checkbox
              checked={filters.general_nurse}
              onChange={toggle("general_nurse")}
              icon={<RadioButtonUncheckedIcon />}
              checkedIcon={<CheckCircleIcon color="secondary" />}
            />
          }
          label="Enfermera General"
        />

        <FormControlLabel
          className="filter_checkbox"
          control={
            <Checkbox
              checked={filters.online_advice}
              onChange={toggle("online_advice")}
              icon={<RadioButtonUncheckedIcon />}
              checkedIcon={<CheckCircleIcon color="secondary" />}
            />
          }
          label="Asesoría en línea"
        />
      </div>

      <div className="filter_section">
        <h3>Ubicación</h3>
        <AutocompleteField
          label="Comunas"
          endpoint="/locations/comunas/list"
          renderValues={["label", "region"]}
          multiple={true}
          value={filters.locations}
          onChange={(data: any) => setFilters({ ...filters, locations: data ? data : [] })}
        />
      </div>

      <div className="filter_section">
        <h3>Procedimientos</h3>
        <AutocompleteField
          label="Procedimientos"
          endpoint="/skills/list"
          endpoint_params={
            filters.advanced_wound_care ? { nurse_type: 'specialist' }
            : filters.general_nurse ? { nurse_type: 'general' }
            : {}
          }
          renderValues={["label", "description"]}
          multiple={true}
          value={filters.skills}
          onChange={(data: any) => setFilters({ ...filters, skills: data ? data : [] })}
        />
      </div>
    </Box>
  );
}
